module.exports = __webpack_public_path__ + "img/Frame 40.1d5c66e2.jpg";